import React from 'react';
import { Spin } from 'antd';

const Loading: React.FC = () => (
  <div className='loading'>
    <Spin />
  </div>
);

export default Loading;
